import {ProcessContentValuesCreate} from '../../../../core/helpers/CoreHelpers';

const initialState = {
    fieldDefinitions: [],
    contentDefinitionKey: null,
    relatedContents: [],
    contentFields: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'PREVIEW_RESET':
            return initialState;
        case 'SET_PREVIEW_FIELD_DEFINITIONS':
            return {
                ...state,
                fieldDefinitions: action.payload,
            };
        case 'SET_PREVIEW_VALUES':
            return {
                ...state,
                values: action.payload.values,
                contentDefinitionKey: action.payload.contentDefinitionKey,
                contentFields: ProcessContentValuesCreate(action.payload.values, state.fieldDefinitions).contentFields,
                relatedContents: action.payload.relatedContents
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/preview.js